import { Grid, MenuItem } from '@mui/material';
import AryAccountsLazyAutoComplete from 'framework/base/components/AryAccountsLazyAutoComplete';
import AryBankAccountsLazyAutoComplete from 'framework/base/components/AryBankAccountsLazyAutoComplete';
import ArySelect from 'framework/base/components/ArySelect';
import { GET_ACCOUNTS } from 'framework/base/constants/aryGraphqlSchemas';
import React from 'react';
import { useAuth } from 'spec';
import useFrameworkTranslation from 'framework/language/useFrameworkTranslation';

const AryCustomerOrBankSelect = ({
  label,
  value,
  accountType,
  handleChangeAccountId,
  disabled,
  isBankDisabled,
  isBank,
  handleChangeIsBank,
  excludedAccountNumbers,
  excludedBankIds,
  excludedMainCurrencies,
  error,
  helperText,
  onBlur,
  onSelectTypeFocus,
  focused
}) => {
  const auth = useAuth();
  const { t } = useFrameworkTranslation();

  const hasGetBankAccountsList = auth.BankAccountsList;

  return (
    <Grid container>
      <Grid item xs={3}>
        <ArySelect
          label=""
          value={isBank}
          onChange={(event) => handleChangeIsBank(event.target.value)}
          disabled={disabled || isBankDisabled}
          onFocus={onSelectTypeFocus}
          focused={focused}
          sx={{
            borderTopRightRadius: '0',
            borderBottomRightRadius: '0',
            mr: '-1px'
          }}
        >
          <MenuItem value={false}>{t('Account')}</MenuItem>
          <MenuItem value>{t('Bank')}</MenuItem>
        </ArySelect>
      </Grid>
      <Grid item xs={9}>
        {!isBank && (
          <AryAccountsLazyAutoComplete
            label={label}
            accountType={
              accountType || GET_ACCOUNTS.accountType.ALL_CAN_BE_CREDITOR
            }
            disabled={disabled}
            excludedAccountNumber={
              excludedAccountNumbers?.length ? excludedAccountNumbers : []
            }
            value={value}
            onChange={handleChangeAccountId}
            error={error}
            helperText={helperText}
            onBlur={onBlur}
            style={{
              control: {
                borderTopLeftRadius: '0',
                borderBottomLeftRadius: '0'
              }
            }}
          />
        )}
        {isBank && (
          <AryBankAccountsLazyAutoComplete
            label={label}
            value={value}
            onChange={(selectedObj) => {
              let newSelectedObj;
              if (!selectedObj) {
                newSelectedObj = selectedObj;
              } else {
                newSelectedObj = { ...selectedObj };
                newSelectedObj.value = newSelectedObj.value.toString();
              }
              handleChangeAccountId(newSelectedObj);
            }}
            excludedBankIds={excludedBankIds || []}
            excludedMainCurrencies={excludedMainCurrencies || []}
            disabled={disabled || !hasGetBankAccountsList}
            error={error}
            helperText={helperText}
            onBlur={onBlur}
            style={{
              control: {
                borderTopLeftRadius: '0',
                borderBottomLeftRadius: '0'
              }
            }}
          />
        )}
      </Grid>
    </Grid>
  );
};

export default AryCustomerOrBankSelect;
